var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var ItalicIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 36,
    glyphHeight: 36
  }), React.createElement("path", {
    d: "M22.8 8L22.688 9.232L20.504 9.54L18.236 27.32L20.476 27.656L20.392 28.804H13L13.14 27.656L15.184 27.32L17.452 9.54L15.548 9.232L15.688 8H22.8Z",
    fill: "black"
  }));
};
export var ItalicIconGlyph = function (props) {
  return React.createElement(ItalicIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};